import { render, staticRenderFns } from "./VATquery.vue?vue&type=template&id=49edb232&scoped=true&"
import script from "./VATquery.vue?vue&type=script&lang=js&"
export * from "./VATquery.vue?vue&type=script&lang=js&"
import style0 from "./VATquery.vue?vue&type=style&index=0&id=49edb232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49edb232",
  null
  
)

export default component.exports